import { render, staticRenderFns } from "./reservoir-list.vue?vue&type=template&id=eca8f79e&scoped=true&"
import script from "./reservoir-list.vue?vue&type=script&lang=js&"
export * from "./reservoir-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca8f79e",
  null
  
)

export default component.exports